import React from "react";

// reactstrap components
import {
  Container
  
} from "reactstrap";

// core components
import ColorNavbar from "components/Navbars/ColorNavbar.js";
import downloadPdfFromJson from "utils/downloadPdfFromJson.js";

function ClasificadaReservada() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("about-us");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("about-us");
    };
  });
  return (
    <>
      <ColorNavbar />
      <div className="main" style={{ marginTop: "10em" }}>
        <div className="section">
          <Container>
            <center className="mt-5">
              <a
                href="#indice-informacion-clasificada-y-reservada"
                role="button"
                style={{ textDecoration: "none !important", cursor: "pointer" }}
                onClick={(e) => {
                  e.preventDefault();
                  downloadPdfFromJson(
                    "/indice-informacion-clasificada-y-reservada.json",
                    "indice-informacion-clasificada-y-reservada.pdf"
                  );
                }}
              >
                <img
                  alt="Imagen con referencia Informacion Clasificada"
                  width="80px"
                  src={require("assets/img/sections/pdf.jpg")}
                ></img>
                <h6 className="my-3">Indice Informacion Clasificada y Reservada</h6>
              </a>
            </center>
          </Container>
        </div>
      </div>
    </>
  );
}

export default ClasificadaReservada;
